import { useState } from 'react';
import { View } from 'react-native';
import { Divider } from 'react-native-elements';
import { Button } from '@/components/ui/therapist/Button';
import Card from '@/components/ui/therapist/Card';
import Checkbox from '@/components/ui/therapist/Checkbox';
import { Input } from '@/components/ui/therapist/Input';
import { Text } from '@/components/ui/therapist/Text';
import { useDashboardContext } from '@/contexts/DashboardContext/useDashboardContext';
import { useOnHover } from '@/hooks/useOnHover';

import styles from './styles';
import colors from '@/config/colors';

type PatientSelectProps = {
  patientIds: string[];
  setPatientIds: React.Dispatch<React.SetStateAction<string[]>>;
};

export const PatientSelect: React.FC<PatientSelectProps> = ({
  patientIds,
  setPatientIds,
}) => {
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [filterValue, setFilterValue] = useState<string>('');
  const { isHovered, handleHoverIn, handleHoverOut } = useOnHover();
  const { patients } = useDashboardContext();

  const handlePatientSelect = (patientId: string) => {
    const index = patientIds?.indexOf(patientId);

    if (index !== -1) {
      setPatientIds((prev: string[]) => {
        const copyOfPatientIds = [...prev];
        copyOfPatientIds.splice(index, 1);
        return copyOfPatientIds;
      });
      return;
    }
    setPatientIds((prev) => [...prev, patientId]);
  };

  return (
    <Card iconCenter="link" iconCentered styleBody={{ padding: 0 }}>
      <View style={styles.headerWrapper}>
        <Button
          icon="filter"
          label="Filter"
          look="tertiary"
          onPress={() => {
            setShowFilter(!showFilter);
            if (showFilter) {
              setFilterValue('');
            }
          }}
          onHoverIn={handleHoverIn}
          onHoverOut={handleHoverOut}
          style={[
            styles.filterButton,
            isHovered && {
              opacity: 0.7,
              backgroundColor: colors.newUI.therapist.blue20,
            },
          ]}
        />
        {showFilter ? (
          <Input
            value={filterValue}
            onChange={(text) => setFilterValue(text)}
            label={''}
            style={{ width: '50%', paddingTop: 10 }}
            placeholder="Patient:in suchen"
          />
        ) : null}
      </View>
      {patients?.length === 0 ? (
        <Text style={styles.noPatients}>Keine Patient:innen gefunden</Text>
      ) : (
        patients
          ?.filter((patient) =>
            (patient.firstName + patient.lastName)
              .toLowerCase()
              .includes(filterValue.toLowerCase()),
          )
          .map((patient, index) => {
            const lastEl = index + 1 === patients?.length;
            const { _id, firstName, lastName } = patient;

            return (
              <View key={index} style={[lastEl && { marginBottom: 10 }]}>
                <View style={styles.patientWrapper}>
                  <Text>{firstName + ' ' + lastName}</Text>
                  <Checkbox
                    label=""
                    isSelected={patientIds.includes(_id)}
                    onPress={() => handlePatientSelect(_id)}
                  />
                </View>
                {!lastEl && (
                  <Divider
                    color={colors.lightGrey}
                    width={2}
                    style={{ marginTop: 10, marginBottom: 10 }}
                  />
                )}
              </View>
            );
          })
      )}
    </Card>
  );
};
